import React, { Suspense } from 'react';
import { Component, ComponentPropertyDefinition, ComponentProps } from '../../types/common';
import { propertiesDefinition, stylePropertiesDefinition } from './promptProperties';
import PromptStyle from './PromptStyle';
import { styleDefaults, stylePropertiesForTheme } from './promptStyleProperties';

const LazyPrompt = React.lazy(() => import(/* webpackChunkName: "Prompt" */ './LazyPrompt'));

function LoadLazyPrompt(props: Readonly<ComponentProps>) {
	return (
		<Suspense fallback={<>...</>}>
			<LazyPrompt {...props} />
		</Suspense>
	);
}

const component: Component = {
	order: 100,
	name: 'Prompt',
	displayName: 'Prompt',
	description: 'AI chat prompt component',
	component: LoadLazyPrompt,
	styleComponent: PromptStyle,
	styleDefaults: styleDefaults,
	propertyValidation: (_props: ComponentPropertyDefinition): Array<string> => [],
	properties: propertiesDefinition,
	styleProperties: stylePropertiesDefinition,
	stylePseudoStates: ['hover'],
	bindingPaths: {
		bindingPath: { name: 'Complete Binding' },
		// Objects the agent really SAVED, as a queue rather than a latest-value
		// slot: one turn writes many, and a page that only sees the last one has
		// silently missed the rest. The handler drains it.
		bindingPath2: { name: 'Changed Objects Binding' },
		// Where another page leaves the question this chat should open with.
		// Point it at a LocalStore path so the handoff survives the navigation,
		// and expect it to be empty afterwards: the chat takes the prompt.
		bindingPath3: { name: 'Pending Prompt Binding' },
	},
	defaultTemplate: {
		key: '',
		name: 'prompt',
		type: 'Prompt',
		properties: {
			agentEndpoint: { value: '/api/ai/appbuilder/chat' },
			placeholder: { value: 'Ask anything' },
			welcomeMessage: { value: 'What can I help with?' },
			showSessions: { value: true },
			showToolCalls: { value: true },
			sessionsPerPage: { value: 20 },
			messagesPerPage: { value: 20 },
		},
	},
	stylePropertiesForTheme: stylePropertiesForTheme,
};

export default component;
